"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableToolbarButton = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const tooltip_1 = require("../../components/tooltip/tooltip");
const table_context_1 = require("./table-context");
exports.TableToolbarButton = react_1.forwardRef(function TableToolbarButton({ className, tooltip, disabled, checked, endIcon, onClick, href, label, primary = checked, secondary, }, ref) {
    const { classes } = react_1.useContext(table_context_1.TableContext);
    return (react_1.default.createElement("li", { className: classes.toolbarButtonWrapper },
        react_1.default.createElement(tooltip_1.Tooltip, { title: tooltip, placement: "top-start" },
            react_1.default.createElement(Button_1.default, { ref: ref, disabled: disabled, className: clsx_1.default(classes.toolbarText, classes.toolbarButton, className), size: "small", component: href ? 'a' : 'span', onClick: onClick, href: href, endIcon: endIcon, color: primary ? 'primary' : secondary ? 'secondary' : 'default', variant: "contained", disableElevation: true }, label))));
});
//# sourceMappingURL=table-toolbar-button.js.map